import { render, staticRenderFns } from "./Circle.vue?vue&type=template&id=5bec0f36&"
import script from "./Circle.vue?vue&type=script&lang=ts&"
export * from "./Circle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports